import { userSegRedirectEntrypoint } from '@jira/redirect-entrypoints__user-seg-redirect/entrypoint.tsx';
import { workItemEntrypoint } from '@atlassian/jira-spa-apps-work-item-view/entrypoint.tsx';
import { createPageEntryPoint } from '@atlassian/jira-create-route-entry-point/src/index.tsx';
import { MENU_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';

export const workItemPageEntrypoint = createPageEntryPoint({
	main: workItemEntrypoint,
	topNavigationMenuId: MENU_ID.WORK_ITEM,
	redirect: userSegRedirectEntrypoint,
});
